import {
  postData,
  showAlert,
  setFormProcessing,
  trimValues,
  getFormDataAsObject,
} from "../util";

document.addEventListener("DOMContentLoaded", () => {
  document.getElementById("email")?.focus();

  const signUpForm = document.getElementById("signup-form");
  signUpForm?.addEventListener("submit", async (e) => {
    e.preventDefault();

    const data = trimValues(getFormDataAsObject(signUpForm));

    if (data.password !== data.passwordConfirm) {
      showAlert({
        icon: "warning",
        title: "Σφάλμα!",
        text: "Οι κωδικοί πρόσβασης πρέπει να είναι ίδιοι!",
      });
      return;
    }

    setFormProcessing(signUpForm, true);

    try {
      delete data.passwordConfirm;
      const res = await postData("/api/company/signup", data);

      if (res && res.body.success) {
        await showAlert({
          icon: "success",
          text: "Ο λογαριασμός σας δημιουργήθηκε. Ελέγξτε το email σας για να τον ενεργοποιήσετε.",
        });
        window.location.replace("/check-email");
      } else {
        showAlert({
          icon: "error",
          text: res.body.error || "Σφάλμα κατά τη δημιουργία λογαριασμού.",
        });
      }
    } catch (error) {
      console.error("Sign-Up Error:", error);
      showAlert({
        icon: "error",
        text: "Κάτι πήγε στραβά.",
      });
    } finally {
      setFormProcessing(signUpForm, false);
    }
  });
});
